export const SET_USER_STATE = "SET_USER_STATE";
export const SET_CONFIG = "SET_CONFIG";
export const RESET_USER_STATE = "RESET_USER_STATE";
export const LOGOUT_CURRENT_USER = "LOGOUT_CURRENT_USER";
